export function QHpassSignUp(events) {
    QHPass.utils.defineError('213', '用户名已经被使用,请重新输入');
    QHPass.utils.defineError('1675', '阅读并同意“360游戏服务及许可协议”和“360游戏隐私政策”');
    QHPass.signUp(events.wrapper, function(userInfo) {
        events.signupSuccCallback(userInfo)
    });
}

